import React from 'react';
import { Users } from '../..';

export const TC_Admin_Users = (props) => (
  <Users title='Users' addNewBtnTitle='Add New User' managedRole='User' {...props} />
);